const menuMessages = {
  organizationDash: 'Organization Dashboard',
  organizationRoster: 'Organization Roster',
  peerSupportDashboard: 'Peer Support Dashboard',
  creatorProfile: 'Creator Profile',
  myProfile: 'My Profile',
  myDash: 'Personal Dashboard',
  contactSupport: 'Contact Support',
  settings: 'Settings',
  becomeCreator: 'Become a Creator',
  signOut: 'Sign Out',
};

export default menuMessages;
